module.exports = __webpack_public_path__ + "img/Inflammation-LICA_PLC.7749e8be.png";